import React from "react";
import { storageService } from "Services/storage_service";
import Principal from "Pages/Principal/Principal";
import DashboardAdmin from "Pages/Dashboard/Administrador/Index";
import { ROLES } from "Constantes/constants";

export default function RutaInicio() {
  const authed = storageService.getItem("user");

  if (authed && authed.idRol !== ROLES.NO_CLIENTE.ID) {
    return <DashboardAdmin />;
  }

  return <Principal />;
}
